export default __webpack_public_path__ + "static/media/img17.01b4c630.svg";